<template>
  <header class="nav-holder">
    <div class="nav-links">
      <router-link to="/">
        <img class="logo" @click="showDropdown = false" v-bind:src="require('@/assets/Logo_Red_New.png')"  alt="company logo"/>
      </router-link>
      <button class="menu-toggle" @click="showDropdown = !showDropdown">
        ☰
      </button>
      <div v-if="showDropdown" class="dropdownMenu">
        <router-link to="/" class="nav-link-singular" @click="showDropdown = false">
          <h3 class="nav-bar-title">Home</h3>
        </router-link>
        <router-link to="/company" class="nav-link-singular" @click="showDropdown = false">
          <h3 class="nav-bar-title">About me</h3>
        </router-link>
      </div>
      <div class="navLinksAll" v-else>
        <router-link to="/" class="nav-link-singular">
          <h3 class="nav-bar-title">Home</h3>
        </router-link>
        <router-link to="/company" class="nav-link-singular">
          <h3 class="nav-bar-title">About me</h3>
        </router-link>
      </div>
    </div>
    <div class="indicatorArea">
      <div class="indicatorMargin">
        <div class="pageIndicator" :style="{backgroundColor: whichRoute === 'home' ? '#db6457' : 'transparent'}"></div>
        <div class="pageIndicator" :style="{backgroundColor: whichRoute === 'company' ? '#db6457' : 'transparent'}"></div>
      </div>
    </div>
  </header>
</template>

<script>
import paletteData from "@/data/colorPalette.json"
export default {
  name: 'ColorPicker',
  props: {
    change_route: Function
  },
  data(){
    return{
      whichRoute: 'home',
      palette: paletteData.palette,
      showDropdown: false,
    }
  },
  watch:{
    '$route.path'(value) {
      if (value === '/') {
        this.whichRoute = 'home';
      } else if (value.startsWith('/company')) {
        this.whichRoute = 'company';
      } else {
        this.whichRoute = 'default';
      }
    }
  }
}
</script>

<style>
.nav-holder {
  width: 100%;
  top: 0;
  z-index: 10;
  background-color: #f7f2ea;
  background-image: url(http://www.transparenttextures.com/patterns/subtle-grunge.png);
  position: sticky;
}
.nav-links {
  height: 3.5rem;
  display: flex;
  justify-content: space-between;
  border-radius: 2vw 2vw 0 0;
  font-family: "Oswald Bold", serif;
  color: #db6457;
}
.logo {
  height: 3.5rem;
  margin: .5rem .5rem .5rem 2rem;
}
.menu-toggle {
  display: none;
  background: none;
  border: none;
  font-size: 3rem;
  height: 4.75rem;
  width: 4.5rem;
  margin: -.25rem 0 0 0;
  cursor: pointer;
  color: #db6457;
}
.navLinksAll {
  display: flex;
  justify-content: flex-end;
  align-items: end;
  margin-right: 2.8rem;
}
.nav-link-singular {
  height: 83%;
  width: 17.5vw;
  color: white;
  border-radius: 1vw 1vw 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pageIndicator {
  height: .3rem;
  width: 11.5vw;
  margin: 0 3vw;
  background-color: #b5e3a6;
}
.indicatorMargin {
  display: flex;
  margin-right: 1.8rem;
}
.indicatorArea {
  margin-left: 1rem;
  display: flex;
  justify-content: flex-end;
  align-items: start;
  height: 1vw;
  width: calc(100% - 2rem);
}
.dropdownMenu {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 4.5rem;
  background-color: #f7f2ea;
  background-image: url(http://www.transparenttextures.com/patterns/subtle-grunge.png);
  padding: 2rem 0 0 0;
  border-radius: 5px;
  width: 100%;
  height: 12rem;
  z-index: 999;
}
.nav-bar-title {
  font-size: 1.6rem;
  margin: 0;
  color: #db6457;
}

/* Media Query for Mobile View */
@media (max-width: 1000px) {
  .nav-holder{
    height: 4.5rem;
  }
  .navLinksAll {
    display: none;
  }
  .menu-toggle {
    display: block;
  }
  .logo {
    height: 3.5rem;
    margin: .5rem .3rem 0 1.5rem;
  }
  .nav-link-singular {
    width: 100%;
    height: 4.5rem;
    font-weight: bold;
    color: black;
  }
  .pageIndicator {
    display: none;
  }
  .indicatorArea {
    margin-top: 3rem;
  }
  .nav-bar-title{
    font-size: 2rem;
  }
}


</style>